import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseTag } from '../components/base-tag/Component.js';
import 'react-merge-refs';
import 'classnames';
import '@alfalab/hooks';

var defaultColors = {"filled":"tag__filled_17u8j"};
require('./default.desktop.css');

var styles = {"rectangular":"tag__rectangular_kzc5l","xxs":"tag__xxs_kzc5l","xs":"tag__xs_kzc5l","s":"tag__s_kzc5l","m":"tag__m_kzc5l","l":"tag__l_kzc5l","xl":"tag__xl_kzc5l"};
require('./desktop.css');

var invertedColors = {"filled":"tag__filled_7a6aa"};
require('./inverted.desktop.css');

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var TagDesktop = forwardRef(function (restProps, ref) { return (React.createElement(BaseTag, __assign({}, restProps, { colorStylesMap: colorStyles, ref: ref, styles: styles }))); });

export { TagDesktop };
